import { getAccessReviewReport as apiGetAccessReviewReport } from "api/accessReviewsReport";
import constate from "constate";
import { Map } from "immutable";
import { type AccessReviewReportModel } from "models/AccessReviewReportModel";
import { useCallback, useState } from "react";

const useAccessReviewReports = () => {
  const [accessReviewReports, setAccessReviewReports] = useState(Map<string, AccessReviewReportModel>());

  const getAccessReviewReport = useCallback(async (id: string): Promise<AccessReviewReportModel | null> => {
    if (!id) return null;
    const accessReviewReport = await apiGetAccessReviewReport(id);
    setAccessReviewReports((current) => current.set(id, accessReviewReport));
    return accessReviewReport;
  }, []);

  return {
    actions: {
      getAccessReviewReport,
    },
    state: { accessReviewReports },
  };
};

export const [AccessReviewReportsProvider, useAccessReviewReportsContext] = constate(useAccessReviewReports);
